/* eslint-disable no-param-reassign */
/* 图形滤镜基类，其他图形继承后实现 drawShape 方法 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

export default class ShapeFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.EleCenter,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.EleCenter;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.SHAPE_CIRCLE;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof ShapeFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        const destinationMap = {
            [Action.ENTR + PresetSubtype.EleCenter]: 'destination-out',
            [Action.ENTR + PresetSubtype.ToEleCenter]: 'destination-in',
            [Action.EXIT + PresetSubtype.EleCenter]: 'destination-in',
            [Action.EXIT + PresetSubtype.ToEleCenter]: 'destination-out',
        };
        canvas.globalCompositeOperation = destinationMap[this.action + this.direction];
        this.drawShape(canvas);
        canvas.globalCompositeOperation = 'source-over';
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected drawShape(canvas: Canvas) {}
}
